export const ToolsSets = [
  // {
  //     "title": "Native Script",
  //     "icon": "nginx",
  //     "color": "onec-orange",
  //     "text": "Over 1 Years experience",
  //     "status": "INTERMEDIET"
  // },
  {
      "title": "Visual Studio",
      "icon": "vs",
      "color": "onec-blue",
      "text": "Over 3 Years experience",
      "status": "INTERMEDIET"
  },
  // {
  //     "title": "Electron",
  //     "icon": "electron",
  //     "color": "onec-blue",
  //     "text": "Over 2 Years experience",
  //     "status": "EXPERT"
  // },
  // {
  //     "title": "React Native",
  //     "icon": "atom",
  //     "color": "onec-green",
  //     "text": "Less 1 Years experience",
  //     "status": "BEGINNER"
  // },
  // {
  //     "title": "Node JS",
  //     "icon": "npm",
  //     "color": "onec-blue",
  //     "text": "Over 2 Years experience",
  //     "status": "INTERMEDIET"
  // },
  {
      "title": "Unity 3D",
      "icon": "unity",
      "color": "onec-gray",
      "text": "Over 3 Years experience",
      "status": "EXPERT"
  },
  // {
  //     "title": "Cocos 2D",
  //     "icon": "cocos",
  //     "color": "onec-gray",
  //     "text": "Less then 1 Years experience",
  //     "status": "INTERMEDIET"
  // },
  {
      "title": "Blender 3D",
      "icon": "blender",
      "color": "onec-orange",
      "text": "Over 8 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "GIT",
      "icon": "git",
      "color": "onec-green",
      "text": "Over 5 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "Photoshop",
      "icon": "ps",
      "color": "onec-darkblue",
      "text": "over 3 Years experience",
      "status": "INTERMEDIET"
  },
  {
      "title": "Illustrator",
      "icon": "ai",
      "color": "onec-orange",
      "text": "Over 3 Years experience",
      "status": "INTERMEDIET"
  },
  {
      "title": "Inkscape",
      "icon": "inkscape",
      "color": "onec-blue",
      "text": "Less then 3 Years experience",
      "status": "INTERMEDIET"
  },
  {
      "title": "GIMP",
      "icon": "gimp",
      "color": "onec-grey",
      "text": "OVER 5 Years experience",
      "status": "EXPERT"
  },
  {
      "title": "MySQL Server",
      "icon": "mysql",
      "color": "onec-orange",
      "text": "OVER 5 Years experience",
      "status": "EXPERT"
  },
  // {
  //     "title": "SQL Server",
  //     "icon": "sql",
  //     "color": "onec-green",
  //     "text": "over 3 Years experience",
  //     "status": "EXPERT"
  // },
  {
      "title": "Android Studio",
      "icon": "and",
      "color": "onec-green",
      "text": "over 5 Years experience",
      "status": "EXPERT"
  },
  {
    "title": "Godot",
    "icon": "godot",
    "color": "onec-blue",
    "text": "over 3 Years experience",
    "status": "EXPERT"
},
  // {
  //     "title": "Eclipse IDE",
  //     "icon": "eclipse",
  //     "color": "onec-ungu",
  //     "text": "Over 1 Years experience",
  //     "status": "INTERMEDIET"
  // },
  // {
  //     "title": "Sublime",
  //     "icon": "sublime",
  //     "color": "onec-gray",
  //     "text": "Over 3 Years experience",
  //     "status": "EXPERT"
  // }
]